export default __webpack_public_path__ + "static/media/marcela-mate-book.52df1c73.png";